import React from "react";
import { Popover as AntdPopover } from "antd";
import { cn } from "../../utils/cn";

const CustomPopover = ({
  content,
  title,
  children,
  placement = "bottomRight",
  trigger = "click",
  variant = "default",
  withArrow = false,
  width = "auto",   
  height = "auto",
  className,
  ...rest
}) => {
  const popupClasses = cn(
    "popover-base",
    {
      "popover-navbar": variant === "navbar",
      "popover-card": variant === "card",
    }
  );

  return (
    <AntdPopover
      content={content}
      title={title}
      placement={placement}
      trigger={trigger}
      classNames={{ popup: { root: popupClasses } }}
      arrow={withArrow}
      {...rest}
    >
      <div
        className={cn("popover-trigger", className)}
        style={{ width, height }}
      >
        {children}
      </div>
    </AntdPopover>
  );
};

export default CustomPopover;
